import { Box, Button, Dialog, DialogTitle, MenuItem, Select, Tooltip, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import AddIcon from "@material-ui/icons/Add";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import { sanitize } from "dompurify";
import FormInputContainer from "legacy-components/form/container/FormInputContainer";
import { Field, FormRenderProps } from "react-final-form";
import { ValidatorBuilderContext } from "legacy-components/form/validator/Validator";
import FormTextInput from "legacy-components/form/input/FormTextInput";
import ActionInliner from "legacy-components/form/action/ActionInliner";
import FormContainer from "legacy-components/form/container/FormContainer";
import { FormApi } from "final-form";
import TeamServices from "../team/TeamService";
import { Alert, Skeleton } from "@material-ui/lab";
import { useHistory } from "react-router";
import { Account } from "./TeamJoiner";
import { AccountDropdown } from "./components/account-dropdown/AccountDropdown";
import {useSelectedAccount} from "./components/account-dropdown/SelectedAccountContext";

export interface TeamCreatorProps {
    refreshUserTeams: any
    joinOpen ?: boolean
    joinToggle ?: () => void
    subscriptionDialogOpen?: boolean
    toggleSubscriptionDialog?: () => void;
    newUser: boolean
    accountsState: any
}
export const Teamcreator: React.FC<TeamCreatorProps> = ({refreshUserTeams, joinOpen, joinToggle, toggleSubscriptionDialog, subscriptionDialogOpen,
  newUser, accountsState
}) => {
    const history = useHistory();
    const { open, toggle } = useDialogProps();
    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(undefined);
    const onCreateTeamClick = () => {
        toggle();
    }
    const intl = useIntl();
    const onCancel = () => {
      toggle();
    }
    const onSuccess = () => {
      toggle();
      if(joinOpen) {
        joinToggle && joinToggle()
      }
      if(subscriptionDialogOpen) {
        toggleSubscriptionDialog && toggleSubscriptionDialog()
      }
      if(newUser) {
        history.push("/home")
      }
    }

    const onSubmit = () => (data: any, form: FormApi) => {
      
      return new Promise((resolve) => {
          const formState = form.getState();

          if (formState.pristine) {
              resolve(null);
          } else {
            TeamServices.createTeam({
                "teamName" : data?.teamName,
                "description" : sanitize(data?.description),
                "accountId" : selectedAccount?.id,
                "accountName" : selectedAccount?.name
            }).subscribe(
                (response) => {
                    refreshUserTeams();
                    onSuccess();
                },
                (error) => {
                    const errorMessage = error?.response?.data?.message || "An error occurred";
                    setErrorMessage(errorMessage);
                }
            )
          }
      });
  }

  useEffect(() => {
    setErrorMessage(undefined);
  }, [toggle]);
  const [enabled, setEnabled] = React.useState(false);

    const [accounts, setAccounts] = useState<Array<Account>>();
    const { selectedAccount, setSelectedAccount } = useSelectedAccount();
    useEffect(()=> {

      if(accountsState?.value) {
        setAccounts(accountsState?.value)
          setSelectedAccount(selectedAccount ?? accountsState?.value?.[0])
      }

    },[ accountsState?.value, accountsState?.loaded])

    const handleAccountChange = (event: any) => {
      const selectedAccountId = event.target.value;
      const selectedAccount:Account|undefined = accounts?.find((account) => account.id === selectedAccountId);
      if (selectedAccount)
        {
          setSelectedAccount( selectedAccount);
        }
    };

    const FormComponents = (formRenderProps: FormRenderProps<{}, {}>) => {
      const validator = useContext(ValidatorBuilderContext);
      return (<>

          <FormInputContainer
             title={<Typography variant="subtitle2">
              <FormattedMessage defaultMessage="Account Name" />
              <span style={{ color: "#DA212C" }}> *</span>
            </Typography> }
          >
            { accounts &&
              <AccountDropdown accounts={accounts}
                selectedAccount={selectedAccount}
                handleAccountChange={handleAccountChange}
                width="100%"
              />
            }
          </FormInputContainer>

          <FormInputContainer
             title={<Typography variant="subtitle2">
              <FormattedMessage defaultMessage="Team Name" />
              <span style={{ color: "#DA212C" }}> *</span>
            </Typography> }
          >
              <Field
                  name="teamName"
                  type="text"
                  //component={FormTextInput}
                  render={({ input, meta }) => (
    <FormTextInput
      {...input as any}
      placeholder={intl.formatMessage({
        defaultMessage: 'Enter the Team Name',
      })}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        input.onChange(e); // still update the form
        if (e.target.value.length > 1 && /^[a-zA-Z0-9-_ ]{2,50}$/.test(e.target.value)) {
          setEnabled(true);
        } else {
          setEnabled(false);
        }
      }}
      meta={meta} // ensure meta is passed if needed
    />
  )}
                  placeholder={intl.formatMessage({
                      defaultMessage: "Enter the Team Name"
                  })}
                  validate={validator.from({
                    required: true,
                    minLength: 2,
                    maxLength: 50,
                    custom: () => (value: string) => {
                      if (value && !/^[a-zA-Z0-9-_ ]{2,50}$/.test(value)) {
                        setEnabled(true)
                        return intl.formatMessage({
                          defaultMessage: "Team Name can only contain letters, numbers, hyphens, and underscores."
                        });
                      }
                      return undefined;
                    }
                  })}
              />
          </FormInputContainer>
        <FormInputContainer  title={<Typography variant="subtitle2" children={<FormattedMessage defaultMessage="Description" />} />}>
          <Field
            name="description"
            type="text"
            multiline
            rows={5}
            component={FormTextInput}
            placeholder={intl.formatMessage({
              defaultMessage: "Enter a short description about your team"
            })}
            validate={validator.from({
              maxLength: 300,
              custom: () => (value: string) => {
                if (value && value.length > 300) {
                  return intl.formatMessage({
                    defaultMessage: "Description must be 300 characters or less."
                  });
                }
                return undefined;
              }
            })}
          />
        </FormInputContainer>
              
          <ActionInliner>
              <Button onClick={onCancel} disabled={formRenderProps.submitting} type="button" variant="outlined" disableElevation> <FormattedMessage defaultMessage="Cancel" /></Button>

              <Button disabled={formRenderProps.submitting || !enabled} type="submit" variant="contained" color="primary" disableElevation> <FormattedMessage defaultMessage="Create Team" /></Button>
          </ActionInliner>
      </>)
  }
    return(
        <>
        {accounts === undefined ? (
    <Skeleton variant="rect" width={200} height={35} />
) : (
    <Tooltip title={!accounts || accounts.length === 0 ? "User without any account cannot create a team" : ""}>
        <div style={{marginLeft: "auto"}}>
            <Button
                startIcon={<AddIcon />}
                onClick={onCreateTeamClick}
                variant="contained"
                color="primary"
                style={{marginLeft: "auto"}}
                disabled={!accounts || accounts.length === 0}
            >
                <FormattedMessage defaultMessage="Create New Team" />
            </Button>
        </div>
    </Tooltip>
)}
        <Box>

            <Dialog
        open={open}
        title="Add New Team"
        onClose={toggle}
        fullWidth={true}
        style={{ padding: "24px 21px" }}
      >
        <div>
          <DialogTitle>
            <FormattedMessage defaultMessage="Create a new Team" />
          </DialogTitle>
        </div>
        {errorMessage && <Box style={{margin: "0px 20px"}}>
        <Alert severity="error"> {errorMessage}</Alert>
        </Box>
        }
        <Box style={{margin: "20px 20px 20px 20px"}}>
     <FormContainer previewErrors={true} FormProps={{ onSubmit }} onSubmitSuccess={onSuccess} children={FormComponents} />
        
        </Box>
      </Dialog>
        </Box>
        </>
    )

}